<template>
  <div id="event-schedule2" class="event-schedule-status2" :class="statusClass" tabindex="-1">
    <span v-if="loading || pending" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
    <div class="event-schedule-copy2">
      <strong>{{ statusLabel }}</strong>
      <small v-if="message">{{ message }}</small>
    </div>
    <div class="event-schedule-actions2">
      <button v-if="failed && !loading" type="button" class="btn btn-outline-primary btn-sm" @click="$emit('check')">Retry</button>
      <template v-if="infeasible && result">
        <button type="button" class="btn btn-primary btn-sm" @click="$emit('move')">Move Event Date to {{ result.controlling_ship_date }}</button>
        <button type="button" class="btn btn-outline-primary btn-sm" @click="$emit('configuration')">Change Program or Style</button>
      </template>
      <button type="button" class="btn btn-link btn-sm" @click="$emit('timing')">Change Timing</button>
    </div>
    <CModal :show="modal" title="This order cannot meet the selected Event Date" @update:show="$emit('cancel')">
      <p>Selected Event Date: {{ result && result.event_date }}</p>
      <p>Controlling calculated ship date: {{ result && result.controlling_ship_date }}</p>
      <p>Controlling group: {{ groupLabel || (result && result.controlling_group_id) }}</p>
      <p>{{ message }}</p>
      <template #footer>
        <button type="button" class="btn btn-primary" @click="$emit('move')">Move Event Date to {{ result && result.controlling_ship_date }}</button>
        <button type="button" class="btn btn-outline-primary" @click="$emit('configuration')">Change Program or Style</button>
        <button type="button" class="btn btn-link" @click="$emit('timing')">Change Timing</button>
        <button type="button" class="btn btn-secondary" @click="$emit('cancel')">Cancel</button>
      </template>
    </CModal>
  </div>
</template>
<script>
export default {
  props: { message: String, authorized: Boolean, loading: Boolean, pending: Boolean, failed: Boolean, modal: Boolean, result: Object, groupLabel: String },
  computed: {
    infeasible () { return !!(this.result && ['infeasible', 'invalid_date', 'invalid_window'].includes(this.result.status)) },
    statusLabel () { if (this.loading) return 'Checking Event Date…'; if (this.failed) return 'Unable to verify Event Date'; if (this.pending) return 'Schedule changed; checking again…'; if (this.authorized) return 'Event Date confirmed'; if (this.infeasible) return 'Cannot meet Event Date'; return 'Checking Event Date…' },
    statusClass () { return { 'is-confirmed': this.authorized, 'is-problem': this.failed || this.infeasible, 'is-pending': this.loading || this.pending } }
  }
}
</script>
<style>
.event-schedule-status2 { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; padding: 10px 12px; margin: 10px 0; border: 1px solid #c8d2dc; border-radius: 6px; background: #f7f9fb; }
.event-schedule-status2.is-confirmed { border-color: #86c99a; background: #eef9f1; color: #236b38; }
.event-schedule-status2.is-problem { border-color: #e1a3a3; background: #fff5f5; }
.event-schedule-copy2 { display: flex; flex: 1 1 240px; flex-direction: column; min-width: 0; }
.event-schedule-copy2 small { color: inherit; }
.event-schedule-actions2 { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; }
@media (max-width: 575px) { .event-schedule-status2 { align-items: flex-start; } .event-schedule-actions2 { width: 100%; } }
</style>
